import axios, { AxiosResponse } from 'axios';
import Equipment, { OneEquipment } from '../models/data/Equipment';
import EquipmentRequest, {
  OneEquipmentRequest,
} from '../models/requests/GetEquipment';
import { createRequestConfig } from './utils';

// 設備情報の取得関数
export function requestEquipment(
  url: string,
  params?: EquipmentRequest,
): Promise<AxiosResponse<Equipment[]>> {
  const config = createRequestConfig({ params });
  return axios.get<Equipment[]>(url, config);
}

// 設備情報の件数の取得関数
export function requestCountEquipment(
  url: string,
  params?: EquipmentRequest,
): Promise<AxiosResponse<number>> {
  const config = createRequestConfig({ params });
  return axios.get<number>(url, config);
}

// 設備情報の件数の取得関数
export function requestOneEquipment(
  url: string,
  params?: OneEquipmentRequest,
): Promise<AxiosResponse<OneEquipment>> {
  const config = createRequestConfig({ params });
  return axios.get<OneEquipment>(url, config);
}
